import { render, staticRenderFns } from "./Ethics.vue?vue&type=template&id=1ee199ac"
import script from "./Ethics.vue?vue&type=script&lang=js"
export * from "./Ethics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports